/* De EMS-routes in het CRM (F9.4, herzien in F9.12).
 *
 * Sinds F9.12 is Locaties de enige ingang: het dashboard staat op de sitepagina
 * (/crm/sites/:siteId, zie src/features/sites/routes.tsx), binnen de CRM-layout.
 * Wat hier overblijft zijn de oude adressen, zodat geen link doodloopt:
 *
 *   /crm/ems              → /crm/sites
 *   /crm/ems/:locatieId   → /crm/sites/<site_id van die locatie>; zonder site, of
 *                           bij een onbekende id, een uitlegscherm met een knop
 *                           naar Locaties (EmsDoorverwijzing.tsx)
 *
 * Waar dit fragment hangt: in App.tsx, BINNEN de /crm-route met CRMLayout (dus
 * achter dezelfde ProtectedRoute en met de gewone zijbalk en kop). De paden zijn
 * daarom relatief. App.tsx, AppSidebar.tsx en GlobalCommand.tsx staan onder de
 * V1-lock; alle drie zijn op 13-09-2026 met toestemming van Stan gewijzigd voor
 * deze verhuizing.
 *
 * De indeling van src/features/ems/ (F9.3, ADR 0010):
 *
 *   dashboard/  GEDEELD. Tekent en rekent: Dashboard.jsx, de vorm van de data,
 *               de configuratie per locatie en haar validator. Importeert alleen
 *               react, three en andere bestanden uit dashboard/. Dezelfde code
 *               draait straks in de klantbuild, dus hier staat niets wat alleen
 *               in het CRM bestaat, en noemt geen klant, ook niet in commentaar.
 *               tests/ems/scheiding en tests/ems/klantnamen bewaken dat.
 *   scenes/     KLANTSPECIFIEK. Handgebouwde 3D-plattegronden, één bestand per
 *               scène. Het dashboard krijgt ze als prop; het CRM registreert ze
 *               allemaal (crm/scenes.js), een klantbuild alleen de eigen.
 *   crm/        ALLEEN CRM. De adapter die met de CRM-sessie leest (leesEms.ts,
 *               crmClient.ts), de React Query-hooks, het ingebedde dashboard
 *               (ui/EmsIngebed.tsx), de EMS-sectie van een site (ui/EmsSectie.tsx),
 *               de doorverwijzing en de lijst met scènes.
 *   routes.tsx  CRM. Blijft hier staan omdat App.tsx (V1-lock) hem op dit pad
 *               importeert.
 */

import { lazy, Suspense } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { Laden } from './crm/ui/Staat';

const EmsDoorverwijzing = lazy(() => import('./crm/pages/EmsDoorverwijzing'));

export const EmsRoutes = (
  <>
    <Route path="ems" element={<Navigate to="/crm/sites" replace />} />
    <Route path="ems/:locatieId" element={
      <Suspense fallback={<Laden tekst="De locatie bij deze link opzoeken…" />}>
        <EmsDoorverwijzing />
      </Suspense>
    } />
  </>
);
